import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AssistantAnswer from "../assistant/AssistantAnswer";
import { useConversationQuery } from "./hooks";

// AssistantMessage dispatches an assistant message's answerJson to the SP1 card
// for its intent via the shared AssistantAnswer dispatcher — the same one
// AnalysisPanel's ThreadItem uses, so the full-page workspace renders
// identically to the slide-over panel.
function AssistantMessage({ answerJson, onNavigate }) {
  // onFollowup: the workspace has no live `ask()` yet (SP2's follow-up input
  // is still a stub, see submitFollowup below) — pass a no-op for now so the
  // chips render but a deeper panel↔workspace unification (wiring a real
  // ask with conversationId + live thread updates) is deferred, same as the
  // existing follow-up input.
  return <AssistantAnswer response={answerJson} onNavigate={onNavigate} onFollowup={() => {}} />;
}

export default function AnalysisWorkspacePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, error } = useConversationQuery(id);
  const [followup, setFollowup] = useState("");

  const onNavigate = (navOrAction) => {
    if (navOrAction?.path) navigate(navOrAction.path);
  };

  if (isLoading) {
    return <div className="h-full bg-background-grey p-8 text-text-3">Loading…</div>;
  }
  if (error || !data?.conversation) {
    return <div className="h-full bg-background-grey p-8 text-text-3">Analysis not found.</div>;
  }

  const { messages = [] } = data;

  const submitFollowup = (e) => {
    e.preventDefault();
    // SP2: minimal follow-up stub — deeper panel↔workspace unification
    // (e.g. wiring useAssistant().ask with conversationId and live thread
    // updates) is deferred to a later task.
    setFollowup("");
  };

  return (
    <div className="h-full flex flex-col bg-background-grey relative">
      <div className="flex-1 overflow-auto p-8 flex flex-col gap-6 max-w-3xl w-full mx-auto">
        {messages.length === 0 && <div className="text-sm text-text-3">No messages yet.</div>}
        {messages.map((m) =>
          m.role === "user" ? (
            <div key={m.id} className="text-sm font-medium text-text-2">{m.questionText}</div>
          ) : (
            <AssistantMessage key={m.id} answerJson={m.answerJson} onNavigate={onNavigate} />
          )
        )}
      </div>

      <form onSubmit={submitFollowup} className="p-3 border-t border-border max-w-3xl w-full mx-auto">
        <input
          value={followup}
          onChange={(e) => setFollowup(e.target.value)}
          placeholder="Ask a follow-up…"
          className="w-full h-10 px-3 rounded-lg bg-surface-2 outline-none text-sm text-text"
        />
      </form>
    </div>
  );
}
